import { useHistory } from 'react-router'
import Card from '@material-ui/core/Card'
import { useEffect, useState } from 'react'
import { ROLES } from '../../../config/user'
import { ITemplate } from '../../../types/templates'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { moneyFormat } from '../../../utils/functions'
import CardContent from '@material-ui/core/CardContent'
import { getTemplate } from '../../../services/templates'
import { useSession } from '../../../context/SessionContext'
import Alert, { ActionsOptType } from '../../../components/Alert'
import { IService, SERVICE_STATUS } from '../../../types/services'

/**
 * define styles for the component
*/
const useStyles = makeStyles({
  root: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: '11rem',
    maxHeight: '11rem', 
    border: '1.5px solid #d3d4d5',
    "&:hover":{
      transform: 'scale(1.05)',
      transition: '0.3s',
      boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.06)"
    },
  },
  title: {
    lineHeight: 1.2,
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    fontSize: '1.2rem',
  },
  media: {
    height: 140,
  },
  description: {
    whiteSpace: 'pre-line',
    marginTop: '1.5vh',
    display:'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 5,
    WebkitBoxOrient: 'vertical',
  },
  actions: {
    justifyContent: 'flex-end',
  },
  priceContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1vh',
  },
})

/**
 * Custom `ShareDocumentItem` component declaration. * 
 * This Component is to define the style of each DocumentItem to show and redirect to editor
 * @param {Object} service
 * @return ShareDocumentItem
*/
const ShareDocumentItem = ({ service }: { service: IService }): JSX.Element => {
  const classes = useStyles()
  const history = useHistory()
  const [template, setTemplate] = useState<ITemplate | null>()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })
  const { user } = useSession()

  // load template data
  useEffect(() => {
    const fetchData = async () => {
      if (service.service_data) {
        const { data } = await getTemplate(service.service_data.template_id)
        if (data) setTemplate(data)
      }
    }
    if (!template) {
      fetchData()
    }
  }, [])

  return (
    <Card
      className={classes.root}
      style={{cursor:'pointer'}}
      onClick={() => {
        if(template)
        {
          {user?.role === ROLES.USER && (
            history.push({
              pathname: `/share-document/${service.id}`,
              state: { service, template, origin: 'SHARE' },
            })
          )}
          {user?.role === ROLES.SUPER_USER && (
            history.push({
              pathname: `/share-document/${service.id}`,
              state: { service, template, origin: 'SHARE' },
            })
          )}
        }
      }}
    >
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <CardContent>
        <Typography
          gutterBottom
          variant="h6"
          component="h5"
          className={classes.title}
        >
          {service?.service_data?.name}
        </Typography>
          <hr style={{marginTop:'13px', marginBottom:'5px'}}/>
        {template && (
          <Typography
            gutterBottom
            variant="body2"
            component="p"
            className={classes.description}
            style={{
              color:
                service.service_status_id === SERVICE_STATUS.PAYMENT_ON_HOLD
                  ? '#F78800'
                  : '#0EBE49',
            }}
          >
            {service.service_status_id === SERVICE_STATUS.PAYMENT_ON_HOLD
              ? `Pago pendiente ${moneyFormat(template.price || 0)}`
              : 'PAGADO'}
          </Typography>
        )}

      </CardContent>
    </Card>
  )
}

export default ShareDocumentItem